export default "__VITE_ASSET__B$f6BHVT__"